import { useEffect } from 'react';

export const IFRAME_DRAG_LOCK_CLASS = 'drag-drop-list-dragging';

export type UseIframeDragLockResult = {
    lockIframes: () => void;
    unlockIframes: () => void;
};

export const useIframeDragLock = (): UseIframeDragLockResult => {
    const lockIframes = (): void => {
        document.body.classList.add(IFRAME_DRAG_LOCK_CLASS);
    };

    const unlockIframes = (): void => {
        document.body.classList.remove(IFRAME_DRAG_LOCK_CLASS);
    };

    useEffect(() => unlockIframes, []);

    return { lockIframes: lockIframes, unlockIframes: unlockIframes };
};
